import styled from 'styled-components';

import { rem } from '../style';
import { MarginProps, marginCss } from './spacing.style';

export const BoxList = styled.ul<
  MarginProps & {
    $gap?: number;
    $alignItems?: 'center' | 'flex-end' | 'flex-start';
    $justifyContent?:
      | 'center'
      | 'flex-end'
      | 'flex-start'
      | 'space-between'
      | 'space-evenly';
    $flexWrap?: 'wrap' | 'nowrap';
    $flexDirection?: 'row' | 'column';
  }
>`
  margin: 0;
  padding: 0;
  list-style: none;

  ${() => marginCss()}
  
  ${({ $gap, $alignItems, $justifyContent, $flexWrap, $flexDirection }) =>
    ($gap || $alignItems || $justifyContent || $flexWrap || $flexDirection) &&
    `
      display: flex;
  `}

  ${({ $gap }) =>
    $gap &&
    `
      gap: ${rem($gap)};
      flex-wrap: wrap;
  `}

  ${({ $alignItems }) =>
    $alignItems &&
    `
      align-items: ${$alignItems};
  `}

  ${({ $justifyContent }) =>
    $justifyContent &&
    `
      justify-content: ${$justifyContent};
  `}

  ${({ $flexWrap }) =>
    $flexWrap &&
    `
      flex-wrap: ${$flexWrap};
  `}

  ${({ $flexDirection }) =>
    $flexDirection &&
    `
      flex-direction: ${$flexDirection};
  `}
`;

export const Box = styled.div<
  MarginProps & {
    $gap?: number;
    $alignItems?: 'center' | 'flex-end' | 'flex-start' | 'baseline';
    $justifyContent?:
      | 'center'
      | 'flex-end'
      | 'flex-start'
      | 'space-between'
      | 'space-evenly';
    $flexWrap?: 'wrap' | 'nowrap';
    $flexDirection?: 'row' | 'column';
    $maxWidth?: number;
  }
>`
  ${() => marginCss()}
  
  ${({ $gap, $alignItems, $justifyContent, $flexWrap, $flexDirection }) =>
    ($gap || $alignItems || $justifyContent || $flexWrap || $flexDirection) &&
    `
      display: flex;
  `}

  ${({ $gap }) =>
    $gap &&
    `
      gap: ${rem($gap)};
      flex-wrap: wrap;
  `}

  ${({ $alignItems }) =>
    $alignItems &&
    `
      align-items: ${$alignItems};
  `}

  ${({ $justifyContent }) =>
    $justifyContent &&
    `
      justify-content: ${$justifyContent};
  `}

  ${({ $flexWrap }) =>
    $flexWrap &&
    `
      flex-wrap: ${$flexWrap};
  `}

  ${({ $flexDirection }) =>
    $flexDirection &&
    `
      flex-direction: ${$flexDirection};
  `}
  
  ${({ $maxWidth }) =>
    $maxWidth &&
    `
      max-width: ${rem($maxWidth)};
  `}
`;
